import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { PFormCheckboxProps } from '@/components/atoms/FormCheckbox/types';

/**
 * `PFormCheckbox` is the design system atom for a labelled form checkbox (distinct from
 * `PCheckbox`, which is the unlabelled selection checkbox used in tables).
 *
 * Accepts `state` for API consistency with the other form-input atoms; `locked` currently renders
 * identically to `disabled` — a checked/unchecked value isn't ambiguous under MUI's dimmed style
 * the way a text value is.
 */
export const PFormCheckbox = ({ label, sx, state = 'enabled', ...other }: PFormCheckboxProps) => {
  return (
    <FormControlLabel
      control={<Checkbox disabled={state !== 'enabled'} {...other} />}
      data-checkbox-label
      sx={sx}
      slotProps={{
        typography: {
          // @ts-expect-error data-checkbox-label isn't in Typography's prop types
          'data-checkbox-label': true,
        },
      }}
      label={label}
    />
  );
};
